import * as React from "react";
const IconMobileCoinTaka = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M34.6 44.2c-.6 0-1 .4-1 1v11.7c0 1.7-1.4 3.2-3.2 3.2H7.2C5.4 60 4 58.6 4 56.8V17.7c0-1.7 1.4-3.2 3.2-3.2h16.9c.6 0 1-.4 1-1s-.4-1-1-1H7.2c-2.8 0-5.2 2.3-5.2 5.2v39.1C2 59.7 4.3 62 7.2 62h23.3c2.8 0 5.2-2.3 5.2-5.2V45.2c-.1-.6-.5-1-1.1-1M56.8 8c-3.4-3.7-8.1-5.8-13.1-6-2.8-.1-5.5.4-8 1.5-.5.2-.7.8-.5 1.3s.8.7 1.3.5c2.3-1 4.7-1.4 7.1-1.3 4.5.2 8.6 2.1 11.7 5.4 3.2 3.4 4.8 7.9 4.7 12.6-.2 5.9-3.3 11.3-8.4 14.4-.5.3-.6.9-.3 1.4.2.3.5.5.9.5.2 0 .4 0 .5-.1 5.6-3.4 9.1-9.4 9.3-16 .2-5.4-1.7-10.4-5.2-14.2" />
    <path d="M21.5 20.4h-5.3c-.6 0-1 .4-1 1s.4 1 1 1h5.3c.6 0 1-.4 1-1s-.5-1-1-1M18.8 49.4c-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6 3.6-1.6 3.6-3.6-1.6-3.6-3.6-3.6m0 5.3c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6 1.6.7 1.6 1.6-.7 1.6-1.6 1.6M45.1 22.9c-.5-.2-1.1 0-1.3.5s0 1.1.5 1.3c1.3.6 2.2 1.9 2.2 3.3 0 2-1.6 3.6-3.6 3.6S39.3 30 39.3 28V17.8H47c.6 0 1-.4 1-1s-.4-1-1-1h-7.7v-3.4c0-.6-.4-1-1-1s-1 .4-1 1v3.4h-1.8c-.6 0-1 .4-1 1s.4 1 1 1h1.8v10.3c0 3.1 2.5 5.6 5.6 5.6s5.6-2.5 5.6-5.6c0-2.3-1.3-4.3-3.4-5.2" />
  </svg>
);
export default IconMobileCoinTaka;
